import { tryCatch } from '@/lib/try-catch'
import {
  deleteMomentImagesPayload,
  deleteMomentImagesPayloadById,
  deleteMomentImagesPayloadByMomentId,
  getMomentImagesPayload,
} from '@/local-db/moment-images'
import { vanillaApiClient } from '@/trpc/vanilla'

import { uploadImages } from './upload-images'

const onError = async ({
  error,
  payloadId,
  momentId,
  message,
}: {
  error: Error
  payloadId?: number
  momentId?: string
  message: string
}) => {
  console.error(message, error)
  if (payloadId) {
    return await deleteMomentImagesPayloadById(payloadId)
  }
  if (momentId) {
    return await deleteMomentImagesPayloadByMomentId(momentId)
  }
  return await deleteMomentImagesPayload()
}

export const saveImages = async () => {
  const payloads = await getMomentImagesPayload()
  const payloadsByMomentId = payloads.reduce(
    (acc, payload) => {
      if (!acc[payload.momentId]) {
        acc[payload.momentId] = []
      }
      acc[payload.momentId].push(payload)
      return acc
    },
    {} as Record<string, typeof payloads>,
  )

  for (const [momentId, payloads] of Object.entries(payloadsByMomentId)) {
    const uploadResults = await Promise.all(
      payloads.map(async (payload) => {
        const { data: imagePath, error: uploadError } = await tryCatch(
          uploadImages({
            image: payload.media,
            fileName: payload.fileName,
            encryptKey: payload.encryptKey,
          }),
        )
        if (uploadError) {
          await onError({
            error: uploadError,
            payloadId: payload.id,
            message: 'Error uploading images',
          })
          return null
        }
        return imagePath
      }),
    )

    const successfulUploads = uploadResults.filter((result) => result !== null)

    const { error: createError } = await tryCatch(
      vanillaApiClient.momentImages.createMany.mutate({
        momentId,
        images: successfulUploads,
      }),
    )

    if (createError) {
      await onError({
        error: createError,
        momentId,
        message: `Error creating moment images for moment id: ${momentId}`,
      })
    }

    await deleteMomentImagesPayloadByMomentId(momentId)
  }

  return await deleteMomentImagesPayload()
}

export default saveImages
